export class MyValuesChoicesModel {
    // private enumType: any;
    public choices: string[];
    public values: string[];

    constructor(EnumType: Object) {
        // this.enumType = EnumType;

        this.values = Object.keys(EnumType);

        this.choices = Object.keys(EnumType).map(key => EnumType[key]);

    }

    // public getChoiceByValue(valueToFind: string) {
    //     return this.choices[this.values.findIndex(value => value === valueToFind)];
    // }

    // public getValueByEnumValue(enumValueToFind: string): string {
    //     return this.values[this.choices.findIndex(choice => choice === enumValueToFind)];
    // }

    // public areEqual( value, enumValue): boolean {
    //     return  this.enumType[value] === enumValue;
    // }
}


